import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

/* import { Plugins } from '@capacitor/core';
const { App } = Plugins;

App.addListener('appUrlOpen', function (data) {
  // Example url: https://beerswift.app/tabs/tabs2
  // slug = /tabs/tabs2
  const slug = data.url.split('.app').pop();

  // We only push to the route if there is a slug present
  if (slug) {
    router.push({
      path: slug,
    });
  }
}); */

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: { name: "Home" },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("../views/Home.vue"),
    meta: { tabBar: true, tabIndex: 0 },
  },
  {
    path: "/stores/:nextRouteName?",
    name: "Stores",
    component: () => import("../views/Stores.vue"),
    meta: { tabBar: true, tabIndex: 1 },
  },
  {
    path: "/store-home",
    name: "StoreHome",
    component: () => import("../views/StoreHome.vue"),
    meta: { tabBar: true, tabIndex: 1 },
  },
  {
    path: "/menu-category/:catID?",
    name: "MenuCategory",
    component: () => import("../views/MenuCategory.vue"),
    meta: { tabBar: true, tabIndex: 1 },
  },
  {
    path: "/menu-item/:catID?",
    name: "MenuItem",
    component: () => import("../views/MenuItem.vue"),
  },
  {
    path: "/menu-full",
    name: "MenuFull",
    component: () => import("../views/MenuFull.vue"),
    meta: { tabBar: true, tabIndex: 1 },
  },
  {
    path: "/order",
    name: "Order",
    component: () => import("../views/Order.vue"),
  },
  {
    path: "/order-bundle",
    name: "OrderBundle",
    component: () => import("../views/OrderBundle.vue"),
  },
  {
    path: "/checkout",
    name: "Checkout",
    component: () => import("../views/Checkout.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/payment",
    name: "Payment",
    component: () => import("../views/Payment.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/giftcard",
    name: "GiftCard",
    component: () => import("../views/GiftCard.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/giftcard-add",
    name: "GiftCardAdd",
    component: () => import("../views/GiftCardAdd.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/offer",
    name: "Offer",
    component: () => import("../views/Offer.vue"),
    meta: { tabBar: true, tabIndex: 2, requiresAuth: true },
  },
  {
    path: "/more",
    name: "More",
    component: () => import("../views/More.vue"),
    meta: { tabBar: true, tabIndex: 3, requiresAuth: true },
  },
];

const router = new VueRouter({
  //mode: 'abstract',
  mode: "history",
  base: process.env.BASE_URL,
  routes,

  scrollBehavior(to, from, savedPosition) {
    //console.log(to);
    //console.log(from);
    //console.log(savedPosition);
    // not work in abstract mode
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  console.log("route", to, from);
  console.log("member", store.state.member);

  store.state.routeFrom = from;
  if (Vue.prototype.$loginAtBegin && to.name != "Login" && store.state.member == null) next({ name: "Login" });
  else if (to.matched.some(route => route.meta.requiresAuth) && store.state.member == null)
    next({ name: "Login", params: { nextRouteName: to.name } });
  else {
    if (to.meta.tabIndex != null) store.state.appTabBarIndex = to.meta.tabIndex;
    next();
  }
});

export default router;
